import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export enum ChevronDownIconVariant {
  DEFAULT,
  SCENARIO,
}

export type ChevronDownProps = { variant?: ChevronDownIconVariant } & IconProps;

export const chevronDownIconVariant: Record<
  ChevronDownIconVariant,
  (props: Except<ChevronDownProps, 'variant'>) => ReactNode
> = {
  [ChevronDownIconVariant.DEFAULT]: ({ iconColor = '#344054', className, ...props }) => (
    <svg
      className={twMerge('shrink-0', className)}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 5.625L8 10.375L12.75 5.625"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.57937"
      />
    </svg>
  ),
  [ChevronDownIconVariant.SCENARIO]: ({ iconColor = '#344054', className, ...props }) => (
    <svg
      className={twMerge('shrink-0', className)}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  ),
};

const ChevronDownIcon: FC<ChevronDownProps> = ({
  variant = ChevronDownIconVariant.DEFAULT,
  ...props
}) => chevronDownIconVariant[variant](props);

export default ChevronDownIcon;
